// extracted by mini-css-extract-plugin
export var messageSideLeft = "_po-1";
export var messageSideRight = "_po-2";
export var orderLookupBubbleContainer = "_po-0";
export var submitButton = "_po-3";